import { t } from 'i18next'

import { SpendLineChart } from '~/modules/retailMedia/components/BudgetConsumptionReport'
import useInView from '~/modules/retailMedia/hooks/useInView'
import {
  isNoSpendDataError,
  useCumulativeDaily
} from '~/modules/retailMedia/hooks/useSpendReports'

import * as S from '../../styles'
import ChartBox from '../ChartBox'
import DailyFilter from '../DailyFilter'

export interface CumulativeDailySectionProps {
  campaignId: string
  selectedDay: string
  onDayChange: (day: string) => void
  dateRange: { start_date: string; end_date: string }
  overviewReady: boolean
  campaignStartAt?: string
}

const CumulativeDailySection = ({
  campaignId,
  selectedDay,
  onDayChange,
  dateRange,
  overviewReady,
  campaignStartAt
}: CumulativeDailySectionProps) => {
  const [ref, isInView] = useInView()
  const { data, isPending, isFetching, error, refetch } = useCumulativeDaily(
    campaignId,
    { date: selectedDay },
    isInView && overviewReady
  )

  return (
    <S.Section ref={ref}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}
      >
        <S.SectionTitle style={{ marginBottom: 0 }}>
          {t('rm:spendReport.section.cumulativeDailySpend')}
        </S.SectionTitle>
        <DailyFilter
          loading={!overviewReady}
          selectedDay={selectedDay}
          onDayChange={onDayChange}
          dateRange={dateRange}
          campaignStartAt={campaignStartAt}
        />
      </div>
      <ChartBox
        loading={!isInView || (isPending && !data && !error)}
        refreshing={isInView && isFetching && (!!data || !!error)}
      >
        {(data || error) && (
          <SpendLineChart
            {...(data ?? {})}
            error={!!error}
            errorMessage={
              isNoSpendDataError(error)
                ? t('rm:spendReport.error.noSpendData')
                : undefined
            }
            onRetry={isNoSpendDataError(error) ? undefined : refetch}
          />
        )}
      </ChartBox>
    </S.Section>
  )
}

export default CumulativeDailySection
